// extracted by mini-css-extract-plugin
export var buttonContent = "_2v-0";
export var centered = "_2v-1";
export var centeredFlex = "_2v-2";
export var errorText = "_2v-3";
export var icon = "_2v-4";
export var iconButtonContent = "_2v-5";
export var monospace = "_2v-6";
export var padded = "_2v-7";